import * as actionTypes from './actionTypes';

const initialState = {
  authDetails: [],
}

const reducer = (state = initialState, action) => {
  // console.log(action)
  switch (action.type) {
    case actionTypes.UPDATE_LOGIN_DETAILS:
      state = {
        ...state,
        authDetails: action.payload,
      }
      break;
    default:
      state = { ...state };
      break;

  }
  // console.log(state);
  return state;
}

export default reducer;